// Components
import ExamAnalysisCard from "./ExamAnalysisCard/ExamAnalysisCard";
import ExternalExamAnalysisCard from "./ExternalExamAnalysisCard/ExternalExamAnalysisCard";

// Utils
import { isRetinaLogikExam } from "src/utils/exams/progressionAnalysisHelper";

// Types
import {
  ProgressionExamSummaryType,
  SelectedProgressionExamType,
} from "src/services/exams/types";

const MAX_EXAM_SELECTION = 10;

type SelectAnalysisCardType = {
  exam: ProgressionExamSummaryType;
  selectedExams: Array<SelectedProgressionExamType>;
  isFetchingExamSection: boolean;
  handleExamSelect: (exam: ProgressionExamSummaryType) => Promise<void>;
  handleExternalExamSelect: (exam: ProgressionExamSummaryType) => Promise<void>;
};

const SelectAnalysisCard = ({
  exam,
  selectedExams,
  isFetchingExamSection,
  handleExamSelect,
  handleExternalExamSelect,
}: SelectAnalysisCardType) => {
  const selectedExam = selectedExams.find((e) => e.id === exam.id);
  const isSelected = Boolean(selectedExam);
  const isDisabled =
    isFetchingExamSection ||
    (!isSelected && selectedExams.length >= MAX_EXAM_SELECTION);

  // Both sources carry the same fields; only the pattern charts and the report
  // fetch differ, which is why the two cards have not been merged as well.
  if (isRetinaLogikExam(exam)) {
    return (
      <ExamAnalysisCard
        examSection={exam}
        selectedExamSection={selectedExam}
        isSelected={isSelected}
        isDisabled={isDisabled}
        handleExamSelect={handleExamSelect}
      />
    );
  }

  return (
    <ExternalExamAnalysisCard
      exam={exam}
      selectedExam={selectedExam}
      isSelected={isSelected}
      isDisabled={isDisabled}
      handleExternalExamSelect={handleExternalExamSelect}
    />
  );
};

export default SelectAnalysisCard;
